import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle } from "./shared";
import { api, imgUrl, optImg } from "../../lib/api";

export default function BlogPreview() {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    api.get("/articles?per_page=3").then((r) => setArticles(r.data.items)).catch(() => {});
  }, []);

  if (!articles.length) return null;

  return (
    <section id="blog" className="py-20 lg:py-28 bg-sand" data-testid="blog-preview-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-2xl">
            <Reveal>
              <Eyebrow>Blog dos Noivos</Eyebrow>
              <SectionTitle>Blog dos Noivos</SectionTitle>
              <p className="mt-4 text-base font-light text-cocoa leading-relaxed">
                Informação, inspiração e orientação para quem está preparando um dos dias mais importantes da vida.
              </p>
            </Reveal>
          </div>
          <Reveal delay={0.15}>
            <Link
              to="/blog"
              data-testid="blog-view-all"
              className="inline-flex items-center gap-2 text-sm font-semibold tracking-wide text-olive hover:text-golddark transition-colors border-b-2 border-gold/40 hover:border-gold pb-1"
            >
              TODOS OS ARTIGOS <ArrowRight className="w-4 h-4" />
            </Link>
          </Reveal>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-7">
          {articles.map((a, i) => (
            <Reveal key={a.id} delay={i * 0.1}>
              <Link to={`/blog/${a.slug}`} className="group block" data-testid={`blog-card-${a.slug}`}>
                <div className="overflow-hidden rounded-2xl">
                  <img
                    src={optImg(a.image, 800)}
                    alt={a.image_alt || a.title}
                    className="w-full aspect-[16/10] object-cover transition-transform duration-700 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <p className="mt-4 text-[11px] uppercase tracking-[0.25em] text-golddark font-semibold">{a.category}</p>
                <h3 className="mt-2 text-xl font-serif text-ink leading-snug group-hover:text-golddark transition-colors">
                  {a.title}
                </h3>
                <p className="mt-2 text-sm font-light text-cocoa line-clamp-2">{a.excerpt}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
